module.exports = "/static/assets/1bd7e4561286956370f8bcc27c43aa82.png";